import { Link } from "react-router-dom";
import { ArrowUpRight, Users, Target, GraduationCap, Award } from "lucide-react";
import Reveal from "@/components/Reveal";
import { RecognitionsStrip } from "@/components/PartnersMarquee";
import { STATS_ABOUT, WHY_US } from "@/data/content";

const ICONS = [Users, GraduationCap, Target, Award];

export default function About() {
  return (
    <div className="pt-24 md:pt-32">
      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24 md:pb-32">
        <Reveal>
          <span className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.24em] text-neutral-500">
            <span className="inline-block w-6 h-px bg-neutral-400" />
            About Us
          </span>
          <h1 className="mt-6 font-serif text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight max-w-5xl">
            Empowering students and professionals through connection & growth.
          </h1>
        </Reveal>

        <div className="mt-16 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <Reveal delay={150}>
              <div className="rounded-3xl overflow-hidden border border-neutral-200 aspect-[4/3]">
                <img
                  src="https://images.pexels.com/photos/7414009/pexels-photo-7414009.jpeg?auto=compress&cs=tinysrgb&w=1600"
                  alt="Diverse entrepreneurs showcasing their startup ideas"
                  className="w-full h-full object-cover"
                />
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={250}>
              <p className="text-lg text-neutral-700 leading-relaxed">
                Scontinent Technologies is a leading IT organization providing internships, professional
                training, certifications, and AI-powered products. We build inclusive bridges between
                learning and livelihood, preparing you for the real world.
              </p>
              <p className="mt-6 text-neutral-600 leading-relaxed">
                We combine deep engineering expertise with a mentor-first approach — helping students
                master live projects while helping companies scale with intelligent software.
              </p>
              <Link to="/contact" className="btn-pill btn-pill--primary mt-10">
                Get in Touch
                <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
              </Link>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="border-t border-neutral-100 bg-[#FAFAFA] py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-2 md:grid-cols-4 gap-8">
          {STATS_ABOUT.map((s) => (
            <div key={s.label} className="border-t border-neutral-300 pt-6">
              <div className="font-serif text-4xl md:text-5xl text-neutral-950">{s.value}</div>
              <div className="mt-2 text-xs uppercase tracking-[0.18em] text-neutral-500">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-24 md:py-32 bg-white border-t border-neutral-100">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.24em] text-neutral-500">
              <span className="inline-block w-6 h-px bg-neutral-400" />
              Why Choose Us
            </span>
            <h2 className="mt-4 font-serif text-4xl md:text-5xl leading-[1.05] tracking-tight">
              Built for real careers, not classrooms.
            </h2>
          </div>
          <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {WHY_US.map((w, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <Reveal key={w.title} delay={i * 80}>
                  <div className="border border-neutral-200 rounded-2xl p-8 h-full hover:border-neutral-900 transition-colors">
                    <Icon className="w-6 h-6 text-neutral-950" strokeWidth={1.5} />
                    <h3 className="mt-6 font-serif text-2xl tracking-tight">{w.title}</h3>
                    <p className="mt-3 text-sm text-neutral-600 leading-relaxed">{w.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white border-t border-neutral-100">
        <div className="max-w-7xl mx-auto px-6 md:px-10 text-center">
          <span className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.24em] text-neutral-800">
            <span className="inline-block w-6 h-px bg-neutral-600" />
            Certified &amp; Recognised
          </span>
          <div className="mt-8">
            <RecognitionsStrip />
          </div>
        </div>
      </section>
    </div>
  );
}
